module.exports = __webpack_public_path__ + "static/media/M002-icon.d9b52710.svg";